var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-tabs',{attrs:{"type":"card"},on:{"change":_vm.callback}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"频次设置"}},[_c('frequencySet')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"白名单IP"}},[_c('whiteListSet')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }